import { render, staticRenderFns } from "./SubMenuTab_OrderDependent.vue?vue&type=template&id=0575934f&scoped=true&"
import script from "./SubMenuTab_OrderDependent.vue?vue&type=script&lang=js&"
export * from "./SubMenuTab_OrderDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575934f",
  null
  
)

export default component.exports